// @ts-nocheck
import {useTranslation} from "react-i18next";
import useGetUserInfo from "../../hooks/useGetUserInfo";
import {useUserSupport} from "../../store/useUserSupport.store";
import UserProfileAvatar from "./UserProfileAvatar";

const containerCls =
  "pt-2 text-[var(--alternative-white)] font-[var(--font-family)] [&_a]:text-[var(--color-primary)] [&_a]:text-[var(--secondary-font-size)] [&_a]:underline [&_a]:cursor-pointer [&_a]:transition-colors [&_a]:duration-300 [&_a:hover]:text-[var(--color-primary)] [&_p]:text-[var(--secondary-font-size)] [&_p]:my-4 [&_p]:mx-0 [&_p]:text-center max-[600px]:[&_p]:mt-3 max-[600px]:[&_p]:mb-4";
const avatarCls = "flex justify-center mt-4 mx-auto mb-6 max-[600px]:mt-3 max-[600px]:mb-4";
const infoRowCls =
  "grid grid-cols-[minmax(0,max-content)_1fr] items-center gap-4 py-2 border-b border-solid border-white/[0.06] last-of-type:border-b-0 [&_h4]:m-0 [&_h4]:text-[var(--secondary-font-size)] [&_h4]:font-medium max-[600px]:py-[var(--space-2)] max-[600px]:gap-3 max-[600px]:[&_h4]:text-sm";
const infoValueCls = "flex flex-col items-end break-words [overflow-wrap:anywhere] !font-normal";

const UserProfile = () => {
  const {data} = useGetUserInfo();
  const {t} = useTranslation();

  const handleSupportModal = useUserSupport(state => state.handleSupportModal);
  const isMobile = window.innerWidth <= 600;
  const avatarSize = isMobile ? 80 : 120;

  const handleAvatarUpload = _file => {
    // TODO: Upload file to server, update user profile, refetch user info, etc.
  };

  return (
    <div className={containerCls}>
      <div className={avatarCls}>
        <UserProfileAvatar
          user={data}
          size={avatarSize}
          onUpload={handleAvatarUpload}
        />
      </div>
      <div className={infoRowCls}>
        <h4>{t("user_alias")}:</h4>
        <h4 className={infoValueCls}>{data?.alias}</h4>
      </div>

      <div className={infoRowCls}>
        <h4>{t("user_name")}: </h4>
        <h4 className={infoValueCls}>
          {data?.given_name ? data.given_name.charAt(0).toUpperCase() + data.given_name.slice(1) : ""}
        </h4>
      </div>

      <div className={infoRowCls}>
        <h4>{t("user_lastName")}: </h4>
        <h4 className={infoValueCls}>
          {data?.family_name ? data.family_name.charAt(0).toUpperCase() + data.family_name.slice(1) : ""}
        </h4>
      </div>

      <div className={infoRowCls}>
        <h4>{t("user_email")}: </h4>
        <h4 className={infoValueCls}>{data?.email}</h4>
      </div>

      <div className={infoRowCls}>
        <h4>{t("user_phoneNumber")}: </h4>
        <h4 className={infoValueCls}>{data?.phoneNumber}</h4>
      </div>

      <div className={infoRowCls}>
        <h4>{t("user_birthdate")}: </h4>
        <h4 className={infoValueCls}>{data?.birthdate}</h4>
      </div>

      <div className={infoRowCls}>
        <h4>{t("user_national_id")}: </h4>
        <h4 className={infoValueCls}>{data?.nationalID}</h4>
      </div>

      <div className={infoRowCls}>
        <h4>{t("user_state")}: </h4>
        <h4 className={infoValueCls}>{data?.state}</h4>
      </div>

      <div className={infoRowCls}>
        <h4>{t("user_city")}: </h4>
        <h4 className={infoValueCls}>{data?.city}</h4>
      </div>
      <p>
        {t("user_support_message")} <a onClick={handleSupportModal}>{t("user_support_link")}</a>
      </p>
    </div>
  );
};

export default UserProfile;
